export default {
  namespaced: true,
  state: {
    adults: 0,
    children: 0,
    infants: 0,
  },
  getters: {
    getAdults: (state) => state.adults,
    getChildren: (state) => state.children,
    getInfants: (state) => state.infants,
  },
  mutations: {
    setAdults(state, value) {
      state.adults = value;
    },
    setChildren(state, value) {
      state.children = value;
    },
    setInfants(state, value) {
      state.infants = value;
    },
  },
};
